import React from "react";
import PropTypes from "prop-types";
import "./Select.scss";
import BaseField from "../Field/Base";
import { bem } from "../../helpers";

export class Select extends BaseField {
  inputType = "select";
  renderOptions(options) {
    if (Array.isArray(options)) {
      return options.map((option, index) => <option key={index} {...option} />);
    } else if (typeof options === "object") {
      return Object.keys(options).map((key) => (
        <optgroup key={key} label={key}>
          {options[key].map((option) => (
            <option {...option} />
          ))}
        </optgroup>
      ));
    }
  }
  renderInput = () => {
    const { id, options, inputProps, disabled, placeholder } = this.props;

    return (
      <select
        id={id}
        name={this.name()}
        value={this.value()}
        className={bem("select", "input")}
        disabled={disabled}
        {...inputProps}
        onChange={this.onChange}
      >
        {placeholder && this.renderOptions([{ label: placeholder, value: "" }])}
        {this.renderOptions(options)}
      </select>
    );
  };
}

Select.propTypes = {
  ...BaseField.propTypes,
  options: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

export default Select;
